"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputMaskPreset = exports.InputType = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
// @ts-nocheck
const react_1 = __importStar(require("react"));
const useRefsCompose_1 = __importDefault(require("../../utils/hooks/useRefsCompose"));
const FieldBox_1 = __importStar(require("../FieldBox"));
const usePlaceholder_1 = __importDefault(require("../../utils/hooks/usePlaceholder"));
// eslint-disable-next-line import/no-cycle
const InputText_1 = __importDefault(require("./fields/InputText"));
// eslint-disable-next-line import/no-cycle
const InputNumber_1 = __importDefault(require("./fields/InputNumber"));
// eslint-disable-next-line import/no-cycle
const InputDate_1 = __importDefault(require("./fields/InputDate"));
// eslint-disable-next-line import/no-cycle
const InputMask_1 = __importDefault(require("./fields/InputMask"));
const ClearButton_1 = __importDefault(require("./components/ClearButton"));
const styles_module_css_1 = __importDefault(require("./styles.module.css"));
const constants_1 = require("./fields/InputMask/constants");
Object.defineProperty(exports, "InputMaskPreset", { enumerable: true, get: function () { return constants_1.InputMaskPreset; } });
var InputType;
(function (InputType) {
    InputType["Text"] = "text";
    InputType["Password"] = "password";
    InputType["Number"] = "number";
    InputType["Date"] = "date";
    InputType["Email"] = "email";
    InputType["Tel"] = "tel";
    InputType["Url"] = "url";
})(InputType || (exports.InputType = InputType = {}));
const fieldsByType = {
    [InputType.Text]: InputText_1.default,
    [InputType.Password]: InputText_1.default,
    [InputType.Number]: InputNumber_1.default,
    [InputType.Date]: InputDate_1.default,
};
const Input = react_1.default.forwardRef(({ type, error, disabled, readOnly, before, after, size, palette, placeholder, value = '', active, focused, onInput, onChange, boxComponent: BoxComponent = FieldBox_1.default, unwrap, hinted, hint, align, clearable = true, onClear, mask, activeTarget, nativePlaceholder = false, ...props }, ref) => {
    const fieldRef = (0, react_1.useRef)(null);
    const Field = (mask ? InputMask_1.default : fieldsByType[type]) || InputText_1.default;
    const { handleChange, handleInput, isValueEmpty } = (0, usePlaceholder_1.default)(value, {
        onInput,
        onChange,
    });
    (0, react_1.useEffect)(() => {
        if (focused) {
            ref?.current?.focus();
        }
    }, [focused]);
    const handleClear = (0, react_1.useCallback)(() => (onClear ? onClear() : handleChange('')), [handleChange, onClear]);
    const isRtl = align === FieldBox_1.FieldBoxAlign.Right;
    const showClearButton = clearable && !disabled && !readOnly && !isValueEmpty;
    const beforeContent = isRtl && showClearButton ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: styles_module_css_1.default.inputClearBefore, children: (0, jsx_runtime_1.jsx)(ClearButton_1.default, { onClick: handleClear }) }), before] })) : (before);
    const afterContent = !isRtl && showClearButton ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [after, (0, jsx_runtime_1.jsx)("div", { className: styles_module_css_1.default.inputClearAfter, children: (0, jsx_runtime_1.jsx)(ClearButton_1.default, { onClick: handleClear }) })] })) : (after);
    return ((0, jsx_runtime_1.jsx)(BoxComponent, { fieldRef: (0, useRefsCompose_1.default)(ref, fieldRef), error: error, disabled: disabled, size: size, palette: palette, fieldType: "input", focused: focused, unwrap: unwrap, activeTarget: activeTarget, ...(BoxComponent !== FieldBox_1.default ? { ...props } : {}), children: (0, jsx_runtime_1.jsx)(FieldBox_1.FieldWrap, { active: active, after: afterContent, before: beforeContent, align: align, hinted: hinted, hint: hint, palette: palette, placeholder: !nativePlaceholder && isValueEmpty ? placeholder : undefined, children: (0, jsx_runtime_1.jsx)(Field, { ...props, type: type, value: value, mask: mask, 
                // @ts-ignore
                ref: ref || fieldRef, disabled: disabled, readOnly: readOnly, onChange: handleChange, onInput: handleInput, placeholder: nativePlaceholder ? placeholder : null }) }) }));
});
exports.default = Input;
